import getAxiosInstance from '../../helpers/get_axios_instance'
import { OK } from 'http-status-codes'

class LecturaValoresSilo {
  static lecturaValoresSilos () {
    const axios = getAxiosInstance()
    const promise = axios.get('/lectura_valores_silos')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudieron obtener los datos.')
      return (data.filas[0])
    })
  }
}

export default LecturaValoresSilo
